
import { CustomComponentsProvider } from '@husky-x/gatsby-theme-husky';
import { HistoryList } from '@husky-x/history-list';
import { HistoryMock } from './custom-components-mocks';
import { HistoryMockDk } from './custom-components-mocks-dk';
import { HistoryMockFi } from './custom-components-mocks-fi';
import { HistoryMockNo } from './custom-components-mocks-no';
import React from 'react'

export const wrapRootElement = ({ element }) => (
  <CustomComponentsProvider
    list={[
      {
        key: 'HistoryCustomComponent',
        component: () => <HistoryList {...HistoryMock} />,
      },
      {
        key: 'HistoryCustomComponentDK',
        component: () => <HistoryList {...HistoryMockDk} />,
      },
      {
        key: 'HistoryCustomComponentFI',
        component: () => <HistoryList {...HistoryMockFi} />,
      },
      {
        key: 'HistoryCustomComponentNO',
        component: () => <HistoryList {...HistoryMockNo} />,
      },
    ]}
  >
    {element}
  </CustomComponentsProvider>
);
